<template>
  <div>
    <!-- OCS唛头 装箱授权客户 -->
    <div class="main" v-for="(datas, index) in printData" :key="index" :datas="index">
      <div class="content">
        <div class="top">{{ datas.porder_sn.split('-')[0].substr(datas.porder_sn.split('-')[0].length - 4)
          }}-{{ datas.porder_sn.split('-')[1] }}-{{ datas.number }}</div>
        <div class="midle">
          <div class="left">
            <p class="one">注文書番号:</p>
            <p class="two">{{ datas.order_box.order_sn }}-{{ datas.order_box.box_no }}</p>
            <p class="there">{{ datas.porder.user.realname }} 様</p>
            <p class="one">配送番号：</p>
            <p class="two">{{ datas.porder_sn }}</p>
            <!-- FBA授权 -->
            <p v-if="datas.porder.is_fba" style="font-size: 30px;">
              {{ datas.porder.importer.company }}
            </p>
            <p style="font-size: 30px;" v-if="datas.porder.split_from">原单号:{{ datas.porder.split_from }}</p>
            <p style="font-size: 30px;" v-if="datas.porder.from_porder_sn">原单号:{{ datas.porder.from_porder_sn }}</p>
          </div>
          <div class="right">
            <img src="@/assets/dayindanicon/rakulogo.png" alt="" />
          </div>
        </div>
        <!-- 底部 -->
        <div class="footer">
          <div class="table">
            <div class="table-left">
              <div>
                <span class="one">業務担当:</span>
                <span class="two">{{ datas.porder.y_admin.realname }}</span>
              </div>
              <div>
                <span class="one">出荷担当:</span>
                <span class="two">{{ datas.porder.p_admin.realname }}</span>
              </div>
              <div>
                <span class="one">重量(KG):</span> <span class="two">{{ datas.weight }}</span>
              </div>
              <div>
                <span class="one">箱サイズ(CM):</span>
                <span class="two">{{ datas.length }}×{{ datas.width }}×{{ datas.height }}</span>
              </div>
              <div>
                <span class="one">箱NO: </span>
                <span class="two">{{ datas.number_by_express_no }}/{{ datas.count_by_express_no }}</span>
              </div>
            </div>
            <!--二维码盒子 -->
            <div class="table-right">
              <img :src="datas.url" alt="">
            </div>
          </div>
          <!-- 文本 -->
          <div class="text">
            <p class="title">注意事項：</p>
            <p>
              1.商品受け取り時、段ボール箱に破損や潰れを発見した場合、お手数ですが、開封前に写真の撮影をお願いします。
            </p>
            <p>
              2.間違った商品を受けった場合、業務担当スタッフまでご連絡ください、よろしくお願い申し上げます。
            </p>
            <p></p>
          </div>
          <!-- 底部箱号，件数 -->
          <div class="bottom-box">
            <div class="barcode">
              <!-- 一维码 -->
              <canvas :id="'express_no' + index" style="width: 100%; height: 160px;" />
            </div>
            <div class="express_no">{{ datas.express_no }}</div>
            <div class="ocs-number">
              <img src="../../assets/dayindanicon/ocs-logo.png" alt="" />
              <div class="right"><span>箱号:{{ datas.number }}</span> <span>件数：{{ datas.number_by_express_no }}/{{
      datas.count_by_express_no
    }}</span>
              </div>
            </div>

          </div>
          <p>{{ getDate() }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getDate } from '@/utlis/date'
import { mapState } from 'vuex';
export default {
  computed: {
    ...mapState(
      {
        printData: (state) => state.porderDetail.printData, //要打印的数据
      }
    )
  },

  data() {
    return {
      getDate,
      qrcode_url: ''
    };
  },
  mounted() {
    this.getQRcode()

  },
  methods: {

    // 一维码
    getJsBarcode(selector, data) {
      JsBarcode(selector, data, {
        displayValue: true,

        width: 6,
        margin: 0,
        fontSize: 0,
        displayValue: false,
        lineColor: "#000000",//设置条和文本的颜色。
      });
      this.$forceUpdate();
    },
    // 二维码
    getQRcode() {
      this.printData.forEach((item, index) => {
        this.$QRCode.toDataURL(
          'https://www.rakumart.com/boxDetail?id=' + item.id,
          { errorCorrectionLevel: "L", margin: 0, width: 128 },
          (err, url) => {
            if (err) throw err;
            item.url = url
          }
        );
        this.$forceUpdate()
      })
      this.printData.forEach((item, index) => {
        this.getJsBarcode("#express_no" + index, item.express_no);
      })
    },

  },
}
</script>

<style lang="scss" scoped>
.main {
  width: 1181px;
  height: 1772px;
  background: #ffffff;
  padding: 60px;
  box-sizing: border-box;
  color: #000000 !important;

  div {
    box-sizing: border-box !important;
  }

  .content {
    width: 1061px;
    height: 1652px;
    background: #ffffff;
    border: 8px solid #000000;

    .top {
      // padding-top: 49px;
      // padding-bottom: 43px;
      text-align: center;
      font-size: 80px;

      font-weight: 600;
      line-height: 152px;
      height: 152px;
      color: #000000;
      border-bottom: 8px solid #000000;
    }

    .midle {
      padding: 30px 60px 30px 60px;
      display: flex;
      width: 100%;
      height: 364px;
      justify-content: space-between;
      border-bottom: 8px solid #000000;
      box-sizing: border-box;

      .left {
        .one {
          font-size: 32px;

          font-weight: 400;
          color: #000000;
        }

        .two {
          font-size: 40px;

          font-weight: 600;
          color: #000000;
          margin-top: 10px;
          font-weight: 600;
          margin-bottom: 10px;
        }

        .there {
          font-size: 32px;

          font-weight: 400;
          color: #000000;
          margin-bottom: 10px;
        }

        // .four {
        // }
        // .five {
        // }
      }

      .right {
        img {
          margin-top: 50px;
          width: 279px;
          height: 180px;
        }
      }
    }

    .footer {
      width: 100%;
      height: 1120px;
      padding: 40px 60px 40px 60px;
      box-sizing: border-box;

      .table {
        display: flex;
        box-sizing: border-box;

        .table-left {
          border: 2px solid #0000;
          // background-color: pink;
          width: 555px;
          height: 352px;
          // box-sizing: border-box;
          // background: #fff;
          border: 2px solid #000000 !important;

          div {
            height: 70px;
            display: flex;

            span {
              padding-left: 40px;
              height: 69px;
              display: inline-block;
              line-height: 68px;
              font-size: 32px;

              font-weight: 600;
              color: #000000;
              border: 1px solid #000000 !important;
            }

            .one {
              // width: 292px !important;
              // background-color: pink;
              flex: 1.3;
              font-size: 35px;
            }

            .two {
              // width: 263px !important;
              flex: 1;
              font-size: 35px;
            }
          }
        }

        .table-right {
          margin-left: 54px;
          width: 330px;
          height: 330px;

          margin-top: 10px;

          img {
            width: 100%;
            height: 100%
          }
        }
      }

      .text {
        width: 100%;
        height: 248px;


        .title {
          font-size: 32px;
          font-weight: 400;
          color: #000000;
          line-height: 60px;
          text-align: left;

        }

        p {
          font-size: 24px;
          font-weight: 600;
          color: #000000;
        }

        .red {
          color: #b4272d;
        }
      }

      .bottom-box {
        width: 100%;
        margin-top: 40px;

        .barcode {
          width: 100%;


        }

        .express_no {
          font-size: 48px;
          text-align: center;
          margin: 20px 0;
        }

        .ocs-number {
          display: flex;
          justify-content: space-between;

          img {
            width: 240px;
            height: 92px;
          }
        }

        .right {
          display: flex;

          align-items: center;

          span {
            height: 60px;
            background: #000000;
            font-size: 40px;
            font-weight: 600;
            color: #ffffff;
            line-height: 60px;
            text-align: center;

            &:first-child {
              width: 160px;
              height: 60px;
            }

            &:last-child {
              width: 220px;
              height: 60px;
              margin-left: 40px;
            }
          }
        }
      }

      .danhao {
        width: 941px;
        height: 150px;
        line-height: 150px;
        text-align: center;
        font-size: 100px;

        font-weight: 600;
        color: #000000;
        margin-bottom: 20px;
      }

      >p {
        width: 100%;
        height: 48px;
        line-height: 48px;
        text-align: right;
        font-size: 32px;

        font-weight: 400;
        color: #000000;
      }
    }
  }
}
</style>
